// BD feat start

class QuickAddToCart extends HTMLElement {
  constructor() {
    super();
    this.layout = this.querySelector("[js-hb-quick-layout]");
    this.wrapper = this.querySelector("[js-hb-quick-wrapper]");
    this.quickAddToCartBtn = this.previousElementSibling?.querySelector(
      "[js-hb-quick-add-to-cart-btn]"
    );
    this.variantId = this.getAttribute("data-variant-id");

    // Only initialize if this is not a free gift button
    if (this.quickAddToCartBtn && !this.quickAddToCartBtn.hasAttribute("data-free-gift-button")) {
      this.init();
    }
  }

  init() {
    this.quickAddToCartBtn?.addEventListener("click", () => {
      document.body.classList.add("overflow-hidden");

      // 🔥 Grab data-color and data-opacity
      const color = this.quickAddToCartBtn.getAttribute("data-color") || "#ed6863";
      const opacity = this.quickAddToCartBtn.getAttribute("data-opacity") || "";

      // 🔥 Get product handle
      const productHandle = this.getAttribute("data-product-handle");

      // ✅ Store per product handle instead of overwriting globally
      window.CartMeta = window.CartMeta || {};
      window.CartMeta[productHandle] = { color, opacity };

      console.log("CartMeta updated:", window.CartMeta);
      // const productHandle = this.getAttribute("data-product-handle");
      const hasOnlyDefaultVariant = this.quickAddToCartBtn.getAttribute(
        "data-only-default-variant"
      );

      if (hasOnlyDefaultVariant === "true") {
        const parent = this.quickAddToCartBtn.closest("[js-hb-product-card]");
        this.addToCartBtn = parent.querySelector("[js-hb-atc-btn]");
        this.form = parent.querySelector("[js-hb-form]");
        this.addToCart();
      } else {
        this.render(productHandle);
      }
    });

    this.previousElementSibling?.querySelectorAll("[js-hb-flaviour-option]")?.forEach((option) => {
      option.addEventListener("click", () => {
        this.variantId = option.getAttribute("data-variant-id");
        const productHandle = this.getAttribute("data-product-handle");
        this.render(productHandle);
      });
    });

    this.layout?.addEventListener("click", () => {
      this.close();
    });
  }

  render(productHandle) {
    fetch(`${location.origin}/products/${productHandle}?view=quick-cart&variant=${this.variantId}`)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const quickAjaxWrapper = doc.querySelector("[js-hb-quick-wrapper]");
        this.wrapper.innerHTML = quickAjaxWrapper.innerHTML;

        // — wire up close & add-to-cart as before —
        this.closeBtn = this.querySelector("[js-hb-quick-add-to-cart-close-btn]");
        this.closeBtn.addEventListener("click", () => this.close());
        this.open(true);
        this.addToCartBtn = this.querySelector("[js-hb-atc-btn]");
        this.form = this.querySelector("[js-hb-form]");
        console.log(this.form);
        this.addToCartBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.addToCart();
        });

        // ◀ NEW: Immediately sync the variant-selects component
        const variantSelectEl = this.wrapper.querySelector("variant-selects");
        if (variantSelectEl) {
          // calculate and apply the correct button/text state
          variantSelectEl.currentVariant();
          variantSelectEl.updateButton();
          // optional: also update images & option visibility
          variantSelectEl.updateVaraintImage(variantSelectEl);
        }
      });
  }

  open(firstLoad) {
    if (firstLoad) {
      setTimeout(() => {
        this.classList.add("active");
      }, 500);
    } else {
      this.classList.add("active");
    }
  }

  close() {
    document.body.classList.remove("overflow-hidden");
    this.classList.remove("active");
  }

  addToCart() {
    const variantStockJsonElement = document.getElementById("variantStockJsonOnCollection");
    if (variantStockJsonElement) {
      const variantStockData = JSON.parse(variantStockJsonElement.textContent);
      const variantId = this.form.querySelector('input[name="id[]"]').value;
      if (variantStockData["variantStock"][variantId]) {
        return;
      }
    }
    this.addToCartBtn.classList.add("loading");
    const submitBtn = this.addToCartBtn;
    const form = this.form;
    const data = {
      form,
      submitBtn,
    };

    document.dispatchEvent(new CustomEvent("quickAddToCart:init", { detail: data }));

    setTimeout(() => {
      this.close();
    }, 1000);
  }
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.variantImageWrapper = this.querySelector("[js-hb-quick-variant-image]");
    this.variantImages = this.querySelectorAll("[js-image]");
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.currentVariant();
    this.updateButton();
    this.updateVaraintImage(e.target);
  }

  getVariantData() {
    return JSON.parse(this.querySelector('[type="application/json"]').textContent);
  }

  getVariantExtraInfoData() {
    return JSON.parse(this.querySelector("[data-quick-cart-variants-json]").textContent);
  }

  updateOptions() {
    const selectedOptions = [];
    [...this.querySelectorAll("select, input")]
      .map((element) => {
        if (element.tagName === "SELECT") {
          return element;
        } else if (element.type === "radio" && element.checked) {
          return element;
        }
        return null;
      })
      .filter((element) => {
        if (element !== null) {
          let position = Number(element.getAttribute("data-option-position"));
          selectedOptions[position - 1] = element.value;
        }
      });
    return selectedOptions;
  }

  updateVaraintImage(target) {
    const currentVariant = this.currentVariant();

    let bgColor;
    const variantExtraInfoJson = this.getVariantExtraInfoData();
    const customButtonOptions = this.querySelectorAll("[js-variant-box]");
    const variantImgEl = this.querySelector("[js-hb-quick-variant-image] [js-image]");
    const defaultOptions = this.querySelectorAll("[js-default-option]");
    const customSelectOptions = this.querySelectorAll("[js-quick-cart-custom-select-option ]");
    const variantsJson = this.getVariantData();

    customButtonOptions.forEach((box) => {
      document.dispatchEvent(
        new CustomEvent("updateCustomButtomOptionsImage:init", {
          detail: { currentTag: box, currentVariant, variantsJson },
        })
      );
      if (currentVariant.available) {
        box.classList.remove("is-hidden");
      } else {
        box.classList.add("is-hidden");
      }
    });

    if (variantImgEl) {
      variantImgEl.setAttribute("src", currentVariant.featured_image.src);
      variantImgEl.setAttribute("srcset", currentVariant.featured_image.src);
      variantImgEl.setAttribute("data-srcset", currentVariant.featured_image.src);
    }

    document.dispatchEvent(
      new CustomEvent("customVariantHideFunction:init", {
        detail: {
          variantExtraInfoJson,
          currentVariant,
          customButtonOptions,
          customSelectOptions,
          defaultOptions,
          variantsJson,
        },
      })
    );

    const selectedOption = target?.querySelector(`[value="${target.value}"]`);
    bgColor = selectedOption?.getAttribute("data-bg-color");

    if (bgColor && currentVariant.featured_image?.src) {
      this.variantImageWrapper.style.backgroundColor = bgColor;
      this.variantImageWrapper
        .querySelector("img")
        .setAttribute("src", currentVariant.featured_image.src);
    }

    if (currentVariant.featured_image?.src) {
      const featuredVariantImageWrapper = this.closest(
        "[js-hb-quick-add-to-cart-widget]"
      ).querySelector("[js-quick-add-product-media]");
      featuredVariantImageWrapper
        .querySelector("img")
        .setAttribute("src", currentVariant.featured_image.src);
    }
  }

  currentVariant() {
    const opts = this.updateOptions(); // e.g. ["Hazelnut Caramel Swirl", undefined]
    return this.getVariantData().find((variant) => {
      // for each variant.optionX, only enforce a match if opts[X] is defined
      return variant.options.every((opt, i) => {
        const sel = opts[i];
        return sel === undefined || sel === opt;
      });
    });
  }

  updateButton() {
    const parent = this.closest("[js-hb-quick-add-to-cart-widget]");
    this.addToCartButton = parent.querySelector("[js-hb-atc-btn]");
    this.addToCartButtonText = parent.querySelector("[js-quick-add-to-cart-btn-text]");
    const variantExtraInfoJson = this.getVariantExtraInfoData();

    let default_variant_stock_badge = "";
    Array.from(variantExtraInfoJson).forEach((variantInfo) => {
      if (variantInfo.id == this.currentVariant().id) {
        default_variant_stock_badge = variantInfo.default_variant_stock_badge;
      }
    });

    if (default_variant_stock_badge !== "") {
      this.addToCartButtonText.innerText = default_variant_stock_badge;
      this.addToCartButton.setAttribute("disabled", "true");
    } else {
      if (this.currentVariant().available) {
        this.addToCartButtonText.innerText = "In den Warenkorb";
        this.addToCartButton.removeAttribute("disabled");
      } else {
        this.addToCartButtonText.innerText = "Ausverkauft";
        this.addToCartButton.setAttribute("disabled", "true");
      }
    }
    // Set quantity for deposit product based on selected variant
    const matchingOption = this.querySelector(
      `option[data-variant-id="${this.currentVariant().id}"]`
    );
    if (matchingOption) {
      const dataQty = matchingOption.getAttribute("data-qty") || "1";
      const quantityInput = this.closest("[js-hb-quick-add-to-cart-widget]")?.querySelector(
        "[js-hb-form] #deposit-quantity"
      );
      if (quantityInput) {
        quantityInput.value = dataQty;
      }
    }
    this.closest("[js-hb-quick-add-to-cart-widget]").querySelector(
      '[js-hb-form] input[name="id[]"]'
    ).value = this.currentVariant().id;
  }
}

customElements.define("variant-selects", VariantSelects);

class FreeGiftQuickPicker extends HTMLElement {
  constructor() {
    super();
    // Prevent multiple instances
    if (window.freeGiftQuickPickerInstance) {
      return window.freeGiftQuickPickerInstance;
    }
    window.freeGiftQuickPickerInstance = this;

    this.isOpen = false;
    this.init();
  }

  init() {
    this.layout = this.querySelector("[js-hb-quick-layout]");
    this.wrapper = this.querySelector("[js-hb-quick-wrapper]");

    if (this.wrapper) {
      this.wrapper.innerHTML = "";
    }

    this.layout?.addEventListener("click", (e) => {
      if (e.target === this.layout) {
        this.close();
      }
    });

    this.bindEvents();
  }

  bindEvents() {
    // Remove any existing event listeners
    document.removeEventListener("click", this.handleGiftButtonClick);

    // Bind the event handler with the correct context
    this.handleGiftButtonClick = this.handleGiftButtonClick.bind(this);
    document.addEventListener("click", this.handleGiftButtonClick);
  }

  handleGiftButtonClick(e) {
    const attributes = {
      _ups_product: "true",
      _threshold: e.target.getAttribute("data-threshold"),
      _price: e.target.getAttribute("data-price"),
    };
    const giftButton = e.target.closest("[data-free-gift-button]");
    if (!giftButton) return;

    e.preventDefault();
    e.stopPropagation();

    if (this.isOpen) return;

    const variantId = giftButton.getAttribute("data-variant-id");
    const productHandle = giftButton.getAttribute("data-product-handle");

    this.openQuickPicker(productHandle, variantId, attributes);
  }

  openQuickPicker(productHandle, variantId, attributes) {
    if (this.isOpen) return;

    this.isOpen = true;
    document.body.classList.add("overflow-hidden");
    this.layout.classList.add("active");

    this.wrapper.innerHTML = "";

    fetch(`${location.origin}/products/${productHandle}?view=quick-cart&variant=${variantId}`)
      .then((response) => response.text())
      .then((html) => {
        if (!this.isOpen) return;

        const doc = new DOMParser().parseFromString(html, "text/html");
        const quickAjaxWrapper = doc.querySelector("[js-hb-quick-wrapper]");

        const price = quickAjaxWrapper.querySelector(".hb_quick_addCart__price");
        price.innerText = `kostenlos`;

        if (quickAjaxWrapper) {
          this.wrapper.innerHTML = quickAjaxWrapper.innerHTML;
        }

        const closeBtn = this.querySelector("[js-hb-quick-add-to-cart-close-btn]");
        if (closeBtn) {
          closeBtn.addEventListener("click", () => this.close());
        }

        this.classList.add("active");
        this.wrapper.classList.add("active");

        const addToCartBtn = this.querySelector("[js-hb-atc-btn]");
        const form = this.querySelector("[js-hb-form]");

        if (addToCartBtn && form) {
          addToCartBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.addFreeGiftToCart(form, addToCartBtn, attributes);
          });
        }
      })
      .catch((error) => {
        console.error("Error loading quick picker:", error);
        this.close();
      });
  }

  close() {
    document.body.classList.remove("overflow-hidden");
    this.classList.remove("active");
    this.layout.classList.remove("active");
    this.wrapper.classList.remove("active");

    setTimeout(() => {
      this.isOpen = false;
      if (!this.isOpen) {
        this.wrapper.innerHTML = "";
      }
    }, 300);
  }

  addFreeGiftToCart(form, submitBtn, attributes) {
    // Add hidden input fields for each attribute
    for (const [key, value] of Object.entries(attributes)) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${key}]`;
      input.value = value;
      form.appendChild(input);
    }

    submitBtn.classList.add("loading");
    const data = {
      form,
      submitBtn,
    };

    document.dispatchEvent(new CustomEvent("quickAddToCart:init", { detail: data }));

    setTimeout(() => {
      this.close();
    }, 1000);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleGiftButtonClick);
    window.freeGiftQuickPickerInstance = null;
  }
}

// Clean registration of components
customElements.define("quick-add-to-cart", QuickAddToCart);
customElements.define("free-gift-quick-picker", FreeGiftQuickPicker);

// BD feat end
